import React, { PureComponent } from "react";
import Page from "../Page";

export default class RegistrationClosedPage extends PureComponent {
  componentDidMount = () => {};

  render() {
    return (
      <Page showHeader={true} title="">
        <div className="row mt-3 text-center">
          <div className="col">
            <h1>Registration is closed</h1>
          </div>
        </div>
      </Page>
    );
  }
}
